import { parseTierPrices, parseTierRanges, priceByCurrencyMapSelector } from 'tiered-pricing/utils/pricing';
import { getCurrencyCodeForPriceProperty } from 'customer-data-objects/lineItem/PropertyNames';
import { useMemo } from 'react';
import { useAdditionalPropertyValues } from '../../../v2/hooks/useAdditionalPropertyValues';
import { useProperty } from '../../../v2/hooks/useProperty';
export const useHasMissingTieredPrices = () => {
  var _getCurrencyCodeForPr;
  const property = useProperty();
  const currencyCode = (_getCurrencyCodeForPr = getCurrencyCodeForPriceProperty(property.name)) !== null && _getCurrencyCodeForPr !== void 0 ? _getCurrencyCodeForPr : undefined;
  const {
    data
  } = useAdditionalPropertyValues({
    tierRanges: 'hs_tier_ranges',
    tierPrices: 'hs_tier_prices'
  });
  const tierRanges = useMemo(() => data !== null && data !== void 0 && data.tierRanges ? parseTierRanges(data.tierRanges) : undefined, [data]);
  const tierPrices = useMemo(() => data !== null && data !== void 0 && data.tierPrices ? priceByCurrencyMapSelector(parseTierPrices(data.tierPrices)) : undefined, [data]);
  return useMemo(() => {
    return tierPrices && tierRanges && !tierRanges.every((__, tierIndex) => {
      var _tierPrices;
      return (tierPrices === null || tierPrices === void 0 || (_tierPrices = tierPrices[currencyCode !== null && currencyCode !== void 0 ? currencyCode : 'undefined']) === null || _tierPrices === void 0 || (_tierPrices = _tierPrices[tierIndex]) === null || _tierPrices === void 0 ? void 0 : _tierPrices.price) != null;
    });
  }, [currencyCode, tierPrices, tierRanges]);
};